import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { IncludeContentWithStyles } from 'bricks/IncludeContent/IncludeContentWithStyles';
import { SharedZoneBlocks, SharedZoneBeautyContent } from 'store/SharedZone/blocks/selectors';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';

import { SignBlock } from './components';
import styles from './styles.pcss';
import typographyStyles from './typography/styles.pcss';

const cx = classNames.bind(styles);
const IncludeBeautyContent = IncludeContentWithStyles(classNames.bind(typographyStyles));

function BeautyContentBlockLayout({ markup, isMobile }) {
  return (
    <div className={cx('component', isMobile ? 'mobile' : '')}>
      <IncludeBeautyContent htmlContent={markup} className={isMobile ? 'mobile' : ''} />
      <SignBlock {...{ isMobile }} />
    </div>
  );
}

BeautyContentBlockLayout.propTypes = {
  markup: PropTypes.string,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  markup: SharedZoneBeautyContent.getMarkup(state),
  isMobile: isScreenBelow640(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(BeautyContentBlockLayout);
